import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { CnafContacterMaCafService } from '../services/contactermacaf.service';
import { forkJoin } from 'rxjs';
import { LIBELLE_FORMULAIRE, LIBELLE_STAT, ETAT_CAMILLE, LIBELLE_EVENT_CAMILLE, REGEX_COURRIEL, LIBELLE_MOTIF } from '../constants/configlibelles';
import { CnafUserService, CnafAtTagService, ClickInfo, NgCnafFormFocusToFirstInvalidDirective } from '@cnaf/ng-cnaf-commons';
import { Router } from '@angular/router';
import { GlobalPubSubService } from '../services/globalpubsub.service';
import { Validators, NgForm, FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { TagXitiService } from '../services/tagxiti.service';
import { context } from '../../../src/contexts/context';

@Component({
  selector: 'cnaf-contacter-caf-courriel',
  templateUrl: './contactercafcourriel.component.html',
  styleUrls: ['./contactercafcourriel.component.css']
})
export class ContacterCafCourrielComponent implements OnInit, AfterViewInit {

  etat: string;
  isCamilleAutorisee: boolean;
  email: string;
  nomCaf: string;
  transactionId: number;
  QUERY_SOURCE = 'CMC';
  motifsResponse: any;
  listeObjetMessage: any[];
  listeMotifReclamation: any[];
  listeMotifs: string[];
  selObjetMessage: any;
  motif1: any;
  motif2: any;
  motif3: any;
  motif4: any;
  motif5: any;
  chargementMotif: boolean;
  selectedMotif: any;
  indicateursSite: any;
  reponsesCamille: any;
  isDisabled: boolean;
  codeOrga: string;
  questionCamille: string;
  selMotifReclamation: any;
  listePrestation: any[];
  selPrestation: any;
  messageCourriel: string;

  myForm!: FormGroup<{
    selObjetMessage: FormControl<string | null>,
    motif1: FormControl<string | null>,
    motif2: FormControl<string | null>,
    motif3: FormControl<string | null>,
    motif4: FormControl<string | null>,
    motif5: FormControl<string | null>,
    selMotifReclamation: FormControl<string | null>,
    selPrestation: FormControl<string | null>,
    messageCourriel: FormControl<string | null>,
    questionCamille: FormControl<string | null>
  }>;

  selObjetMessageIsEmptyJson: boolean;
  clickInfo!: ClickInfo;
  submitted: boolean;
  URL_REPONSE = 'contactcafcourriel/reponses';


  @ViewChild('contaterParCourrielNgForm', { static: false }) public contaterParCourrielNgForm!: NgForm;

  validatorNotEmpty = [
    Validators.minLength(1)
  ];

  constructor(protected readonly cnafContacterMaCafService: CnafContacterMaCafService,
              private readonly cnafUserService: CnafUserService,
              private readonly router: Router,
              private readonly globalPubSubService: GlobalPubSubService,
              private readonly formBuilder: FormBuilder,
              private readonly tagXitiService: TagXitiService,
              private readonly cnafAtTagService: CnafAtTagService,
              private readonly elementRef: ElementRef,
              private readonly changeDetectorRef: ChangeDetectorRef) {
    this.myForm = this.formBuilder.group({
      selObjetMessage: '',
      motif1: '',
      motif2: '',
      motif3: '',
      motif4: '',
      motif5: '',
      selMotifReclamation: [''],
      selPrestation: [''],
      messageCourriel: [''],
      questionCamille: ['',
        {
          allowInvalid: true,
          updateOn: 'blur'
        }
      ]
    });

    this.etat = 'loading';
    this.isCamilleAutorisee = false;
    this.email = '';
    this.nomCaf = '';
    this.transactionId = 0;
    this.motifsResponse = {};
    this.listeObjetMessage = [];
    this.listeMotifReclamation = [];
    this.listeMotifs = [];
    this.selObjetMessage = {};
    this.motif1 = {};
    this.motif2 = {};
    this.motif3 = {};
    this.motif4 = {};
    this.motif5 = {};
    this.chargementMotif = false;
    this.selectedMotif = {};
    this.indicateursSite = {
      x11: '',
      x12: '',
      x13: ''
    };
    this.reponsesCamille = {};
    this.isDisabled = false;
    this.codeOrga = this.cnafUserService.codeOrga;
    this.questionCamille = '';
    this.selMotifReclamation = {};
    this.listePrestation = [];
    this.selPrestation = {};
    this.messageCourriel = '';
    this.selObjetMessageIsEmptyJson = true;
    this.submitted = false;
    this.fcontact.selObjetMessage.valueChanges.subscribe((value: any) => {
      this.questionCamilleInput.setValidators(null);
      this.questionCamilleInput.markAsUntouched();
      this.questionCamilleInput.setValue('');

      this.messageCourrielInput.setValidators(null);
      this.messageCourrielInput.markAsUntouched();
      this.messageCourrielInput.setValue('');

      this.selMotifReclamationInput.setValidators(null);
      this.selMotifReclamationInput.markAsUntouched();
      this.selMotifReclamationInput.setValue('');

      this.selObjetMessage = value;
      this.selObjetMessageIsEmptyJson = false;
      if (value.code !== 'INFO_REC') {
        if (this.isCamilleAutorisee) {
          this.questionCamilleInput.setValidators(
            [Validators.required, Validators.minLength(1), Validators.maxLength(150)]);
        }
        else {
          this.messageCourrielInput.setValidators(
            [Validators.required].concat(this.validatorNotEmpty));
        }
      }
      else {
        this.messageCourrielInput.setValidators(
          [Validators.required].concat(this.validatorNotEmpty));
        this.selMotifReclamationInput.setValidators(
          [Validators.required].concat(this.validatorNotEmpty));
      }

      this.myForm.controls['motif1'].setValue('');
      this.myForm.controls['motif2'].setValue('');
      this.myForm.controls['motif3'].setValue('');
      this.myForm.controls['motif4'].setValue('');
      this.myForm.controls['motif5'].setValue('');

      if (this.selObjetMessage && !this.selObjetMessage.selectionnable) {
        this.selObjetMessageIsEmptyJson = true;
        this.myForm.controls['selObjetMessage'].setErrors({ required: true });
      }

      this.questionCamilleInput.updateValueAndValidity();
      this.messageCourrielInput.updateValueAndValidity();
      this.selMotifReclamationInput.updateValueAndValidity();
    });

    this.fcontact.motif1.valueChanges.subscribe(value => {
      if (value){
        this.motif1 = value;
      }
    });
    this.fcontact.motif2.valueChanges.subscribe(value => {
      if (value){
        this.motif2 = value;
      }
    });
    this.fcontact.motif3.valueChanges.subscribe(value => {
      if (value){
        this.motif3 = value;
      }
    });

    this.fcontact.motif4.valueChanges.subscribe(value => {
      if (value){
        this.motif4 = value;
      }
    });

    this.fcontact.motif5.valueChanges.subscribe(value => {
      if (value){
        this.motif5 = value;
      }
    });
    this.fcontact.selMotifReclamation.valueChanges.subscribe((value: any) => {
      this.selPrestationInput.setValidators(null);
      this.selPrestationInput.markAsUntouched();
      this.selPrestationInput.setValue('');
      this.selMotifReclamation = value;
      if (value.famille === 'dossier') {
          this.selPrestationInput.setValidators(
            [Validators.required].concat(this.validatorNotEmpty));
      }

      if (this.selMotifReclamation && !this.selMotifReclamation.selectionnable) {
        this.myForm.controls['selMotifReclamation'].setErrors({ required: true });
      }

      this.selPrestationInput.updateValueAndValidity();
    });
    this.fcontact.selPrestation.valueChanges.subscribe((value: any) => {
      this.selPrestation = value;

      if (this.selPrestation && !this.selPrestation.selectionnable) {
        this.myForm.controls['selPrestation'].setErrors({ required: true });
      }
    });
    this.fcontact.messageCourriel.valueChanges.subscribe((value: any) => {
      this.messageCourriel = value;
    });

    this.fcontact.questionCamille.valueChanges.subscribe((value: any) => {
      this.questionCamille = value;
    });
  }

  get questionCamilleInput() { return this.myForm.controls['questionCamille']; }
  get messageCourrielInput() { return this.myForm.controls['messageCourriel']; }
  get selMotifReclamationInput() { return this.myForm.controls['selMotifReclamation']; }
  get selPrestationInput() { return this.myForm.controls['selPrestation']; }
  get fcontact() { return this.myForm.controls; }

  ngOnInit(): void {
    if (this.currentRoute() === `/${this.URL_REPONSE}` && !this.cnafContacterMaCafService.reponsesGeneres) {
      this.router.navigate(['contactcafcourriel']);
    }
    this.recupererInfos();
    this.listeObjetMessage = LIBELLE_FORMULAIRE.listeObjetMessage;
    this.listeMotifReclamation = LIBELLE_FORMULAIRE.listeMotifReclamation;
    this.listeMotifs = LIBELLE_MOTIF;
    this.listePrestation = LIBELLE_FORMULAIRE.listePrestation;
    this.globalPubSubService.contacterCafCourrielComponent = this;
    this.globalPubSubService.subscribe(LIBELLE_EVENT_CAMILLE.envoi, this.libelleEventCamilleEnvoi);
    this.globalPubSubService.subscribe(LIBELLE_EVENT_CAMILLE.envoiOk, this.libelleEventCamilleEnvoiOk);
    this.globalPubSubService.subscribe(LIBELLE_EVENT_CAMILLE.envoiKo, this.libelleEventCamilleEnvoiKo);
    this.globalPubSubService.subscribe(LIBELLE_EVENT_CAMILLE.reset, this.libelleEventCamilleReset);
    this.cnafContacterMaCafService.statsSidAccesRubrique('', 'ACCDIAWEB');
    const tagObj = this.tagXitiService.getAtTagObject('contactcafcourriel', context.type, 'contactermacaf', '', '');
    this.cnafAtTagService.pageSend(tagObj);
  }

  ngAfterViewInit(): void {
    this.changeDetectorRef.detectChanges();
  }

  libelleEventCamilleEnvoi(args: any): void {
    this.etat = 'loading';
  }

  libelleEventCamilleEnvoiOk(args: any): void {
    let rnProductSelected = '';
    if (args.args2) {
      const res = args.args2.split('_');
      if (res[2]) {
        rnProductSelected = `SOUSMOTIF=${res[2]}`;
      }
    }
    this.cnafContacterMaCafService.statsSidAccesRubrique(rnProductSelected, 'DIAENTENFWEB');
    this.etat = 'postFormOk';
  }

  libelleEventCamilleEnvoiKo(args: any): void {
    this.etat = 'postFormKo';
  }

  libelleEventCamilleReset(args: any): void {
    this.resetMotifs();
  }

  loadedOrReponsesCamille(): string {
    return ((this.etat === 'loaded') || (this.etat === 'reponsesCamille')) ? this.etat : '';
  }

  recupererInfos(): void {
    forkJoin(this.cnafContacterMaCafService.recupererInfos()).subscribe(
      (response) => {
        const returnData = response;
        // Autorisation de creer des courrielAutorise
        if (!returnData[2].courrielAutorise) {
          this.etat = "nonAutorise";
          //Adresse Email null ou vide
        } else if (this.cnafContacterMaCafService.isUndefOrNull(returnData[0].adresseEmail) || returnData[0].adresseEmail.length === 0) {
          this.etat = 'emailVide';
        } else {
          // Recuperation des informations du dossier
          this.email = returnData[0].adresseEmail;
          this.isCamilleAutorisee = returnData[0].camilleAutorisee;
          // Recuperation des infos de la caf
          this.nomCaf = returnData[1].caf_nom;
          this.cnafContacterMaCafService.setNomCaf(this.nomCaf);
          // Initialisation Camille si RecupsOK
          if (this.isCamilleAutorisee) {
            const params = {
              transactionId: this.transactionId,
              pointEntree: this.QUERY_SOURCE
            };
            this.cnafContacterMaCafService.getMotifs(
              params
            ).subscribe({
              next: (data: any) => {
                this.getMotifsOk(data);
              },
              error: () => {
                this.getMotifsKo();
              }
            });
          } else {
            this.etat = 'loaded';
          }
        }
      },
      error => {
        this.etat = 'error';
      }
    );
  }

  getMotifsOk(data: any): void {
    this.transactionId += 1;
    this.motifsResponse = data;
    this.listeObjetMessage = this.mergeMotifsCamille(this.listeObjetMessage, this.motifsResponse.motifs);
    this.etat = 'loaded';
  }

  getMotifsKo(): void {
    this.isCamilleAutorisee = false;
    this.etat = 'loaded';
  }

  mergeMotifsCamille(listeObjetMessage: any[], listeMotifs: any[]): any[] {
    listeObjetMessage.forEach(element => {
      listeMotifs.forEach(elemMotifs => {
        if (element.cleRnProduit === elemMotifs.cleRnProduit) {
          element.idUnique = elemMotifs.idUnique;
          element.idProduit = elemMotifs.idProduit;
          element.sortOrder = elemMotifs.sortOrder;
          element.hasChildren = elemMotifs.hasChildren;
          element.children = elemMotifs.children;
        }
      });
    });
    return listeObjetMessage;
  }

  redirect(url: string): void {
    window.location.href = url;
    window.scrollTo(0, 0);
  }
  updateObjet(): void {
    this.resetMotifs();
    if (this.currentRoute() === `/${this.URL_REPONSE}`) {
      this.router.navigate(['contactcafcourriel']);
    }
  }
  resetMotifs(): void {
    this.motif1 = {};
    this.motif2 = {};
    this.motif3 = {};
    this.motif4 = {};
    this.motif5 = {};
    this.myForm.controls['motif1'].setValue('');
    this.myForm.controls['motif2'].setValue('');
    this.myForm.controls['motif3'].setValue('');
    this.myForm.controls['motif4'].setValue('');
    this.myForm.controls['motif5'].setValue('');
  }
  checkSousMotif(motif: any, level: number): void {
    this.resetMotif(level);
    if (!motif.hasChildren &&
      this.cnafContacterMaCafService.isUndefOrNull(motif.children)) {
      this.submitMotif(motif);
    }
  }
  resetMotif(level: number): void {
    switch (level) {
      case 1:
        this.motif2 = {};
        this.motif3 = {};
        this.motif4 = {};
        this.motif5 = {};
        this.myForm.controls['motif2'].setValue('');
        this.myForm.controls['motif3'].setValue('');
        this.myForm.controls['motif4'].setValue('');
        this.myForm.controls['motif5'].setValue('');
        break;
      case 2:
        this.motif3 = {};
        this.motif4 = {};
        this.motif5 = {};
        this.myForm.controls['motif3'].setValue('');
        this.myForm.controls['motif4'].setValue('');
        this.myForm.controls['motif5'].setValue('');
        break;
      case 3:
        this.motif4 = {};
        this.motif5 = {};
        this.myForm.controls['motif4'].setValue('');
        this.myForm.controls['motif5'].setValue('');
        break;
      case 4:
        this.motif5 = {};
        this.myForm.controls['motif5'].setValue('');
        break;
      case 5:
        return;
      default:
        return;
    }
  }
  submitMotif(motif: any): void {
    this.selectedMotif = motif;

    if (this.currentRoute() === `/${this.URL_REPONSE}`) {
      this.router.navigate(['contactcafcourriel'], {
        state: {
          scroll: false
        }
      });
    }
    this.chargementMotif = true;
    const data = {
      question: null,
      cleRnProduit: motif.cleRnProduit,
      sessionId: this.motifsResponse.sessionId,
      transactionId: this.transactionId,
      pointEntree: this.QUERY_SOURCE
    };
    this.cnafContacterMaCafService.postQuestion(data).subscribe(
      {
        next: (data: any) => {
          this.postMotifOk(data);
        },
        error: () => {
          this.postMotifKo();
        }
      }
    );
    this.indicateursSite = {
      x11: this.selObjetMessage.libelleCaffr,
      x12: '0',
      x13: motif.libelle
    };
  }

  postMotifOk(responseData: any): void {

    // Gestion Reset Session IMNET
    if (responseData.sessionId !== this.motifsResponse.sessionId) {
      this.motifsResponse.sessionId = responseData.sessionId;
      this.transactionId = 1;
    }
    this.reponsesCamille = responseData;
    this.chargementMotif = false;
    const paramsMessage = {
      email: this.email,
      selObjetMessage: this.selObjetMessage
    };
    this.cnafContacterMaCafService.reponsesGeneres = true;
    if (this.cnafContacterMaCafService.isUndefOrNull(this.reponsesCamille.resultats) || this.reponsesCamille.resultats.length === 0) {
      this.indicateursSite.x12 = '0';
      const tagObj = this.tagXitiService.getAtTagObject('soumettre_base_co', context.type, this.codeOrga, LIBELLE_STAT.libelleContacterMaCaf,
        LIBELLE_STAT.libelleParCourriel, null, this.indicateursSite);
      this.cnafAtTagService.pageSend(tagObj);
      this.router.navigate([this.URL_REPONSE], {
        state: {
          paramsCamille: {
            reponsesCamille: null,
            questionCamille: `${this.selObjetMessage.libelleCaffr}$ ${this.selectedMotif.libelle}`,
            etatCamille: ETAT_CAMILLE.resultatsVide,
            rnProduct: this.selectedMotif.cleRnProduit,
            formuel: true
          },
          paramsMessage,
          scroll: false
        }
      });
    } else {
      this.indicateursSite.x12 = '1';
      const tagObj = this.tagXitiService.getAtTagObject('soumettre_base_co', context.type, this.codeOrga, LIBELLE_STAT.libelleContacterMaCaf,
        LIBELLE_STAT.libelleParCourriel, null, this.indicateursSite);
      this.cnafAtTagService.pageSend(tagObj);

      this.router.navigate([this.URL_REPONSE], {
        state: {
          paramsCamille: {
            reponsesCamille: this.reponsesCamille,
            questionCamille: `${this.selObjetMessage.libelleCaffr}$ ${this.selectedMotif.libelle}`,
            etatCamille: ETAT_CAMILLE.resultatsOk,
            rnProduct: this.selectedMotif.cleRnProduit,
            formuel: true
          },
          paramsMessage,
          scroll: false
        }
      });
    }
    this.etat = 'reponsesCamille';
  }

  postMotifKo(): void {
    this.chargementMotif = false;
    this.cnafContacterMaCafService.reponsesGeneres = true;
    this.router.navigate([this.URL_REPONSE], {
      state: {
        paramsCamille: {
          reponsesCamille: null,
          questionCamille: `${this.selObjetMessage.libelleCaffr}$ ${this.selectedMotif.libelle}`,
          etatCamille: ETAT_CAMILLE.erreur,
          rnProduct: this.selectedMotif.cleRnProduit,
          formuel: true
        },
        paramsMessage: {
          email: this.email,
          selObjetMessage: this.selObjetMessage
        },
        scroll: false
      }
    });
    this.etat = 'reponsesCamille';
  }

  postQuestionOk(responseData: any): void {
    // Gestion Reset Session IMNET
    if (responseData.sessionId !== this.motifsResponse.sessionId) {
      this.motifsResponse.sessionId = responseData.sessionId;
      this.transactionId = 1;
    } else {
      this.transactionId += 1;
    }
    this.reponsesCamille = responseData;
    this.isDisabled = false;
    const paramsMessage = {
      email: this.email,
      selObjetMessage: this.selObjetMessage
    };
    this.indicateursSite.x11 = this.selObjetMessage.libelleCaffr;
    this.indicateursSite.x13 = '';
    this.cnafContacterMaCafService.reponsesGeneres = true;
    if (this.cnafContacterMaCafService.isUndefOrNull(this.reponsesCamille.resultats) || this.reponsesCamille.resultats.length === 0) {
      this.indicateursSite.x12 = '0';
      const tagObj = this.tagXitiService.getAtTagObject('soumettre_base_co', context.type, this.codeOrga, LIBELLE_STAT.libelleContacterMaCaf,
        LIBELLE_STAT.libelleParCourriel, null, this.indicateursSite);
      this.cnafAtTagService.pageSend(tagObj);

      this.router.navigate([this.URL_REPONSE], {
        state: {
          paramsCamille: {
            reponsesCamille: null,
            questionCamille: this.questionCamille,
            etatCamille: ETAT_CAMILLE.resultatsVide,
            formuel: false,
            rnProduct: this.selObjetMessage.cleRnProduit
          },
          paramsMessage
        }
      });
    } else {
      this.indicateursSite.x12 = '1';
      const tagObj = this.tagXitiService.getAtTagObject('soumettre_base_co', context.type, this.codeOrga, LIBELLE_STAT.libelleContacterMaCaf,
        LIBELLE_STAT.libelleParCourriel, null, this.indicateursSite);
      this.cnafAtTagService.pageSend(tagObj);

      this.router.navigate([this.URL_REPONSE], {
        state: {
          paramsCamille: {
            reponsesCamille: this.reponsesCamille,
            questionCamille: this.questionCamille,
            etatCamille: ETAT_CAMILLE.resultatsOk,
            formuel: false,
            rnProduct: this.selObjetMessage.cleRnProduit
          },
          paramsMessage
        }
      });
    }
    this.etat = 'reponsesCamille';
  }

  postQuestionKo(): void {
    this.isDisabled = false;
    this.cnafContacterMaCafService.reponsesGeneres = true;
    this.router.navigate([this.URL_REPONSE], {
      state: {
        paramsCamille: {
          reponsesCamille: null,
          questionCamille: this.questionCamille,
          etatCamille: ETAT_CAMILLE.erreur,
          rnProduct: this.selObjetMessage.cleRnProduit,
          formuel: false
        },
        paramsMessage: {
          email: this.email,
          selObjetMessage: this.selObjetMessage
        }
      }
    });
    this.etat = 'reponsesCamille';
  }

  currentRoute(): any {
    return `/${this.router.parseUrl(this.router.url).root.children['primary'].segments.map(it => it.path).join('/')}`;
  }

  quitterBaseCo(): void {
    if (this.selObjetMessage !== undefined && this.selObjetMessage !== null && this.selObjetMessage.code === 'INFO_REC') {
      this.clickInfo = this.tagXitiService.getAtClickObject('quitter_reclamation', 'action', this.codeOrga, LIBELLE_STAT.libelleContacterMaCaf, LIBELLE_STAT.libelleParCourriel);
      this.cnafAtTagService.click(this.clickInfo);
    } else {
      this.clickInfo = this.tagXitiService.getAtClickObject('quitter_avant_soumettre_base_co', 'action', this.codeOrga,
        LIBELLE_STAT.libelleContacterMaCaf, LIBELLE_STAT.libelleParCourriel);
      this.cnafAtTagService.click(this.clickInfo);
    }
  }
  submitQuestion() : void
    {
      if (this.questionCamille != null && this.questionCamille.trim().length === 0) {
        this.questionCamille = '';
        return;
      }
      this.etat = 'loading';
      // Désactivation du bouton à la soumission
      this.isDisabled = true;
      // Suppression Unicode "Control Characters"
      // Sauf LF,CR,Horizontal TAB
      const question = this.questionCamille.
        replace(REGEX_COURRIEL.value, '');
      const data = {
        question,
        cleRnProduit: this.selObjetMessage.cleRnProduit,
        sessionId: this.motifsResponse.sessionId,
        transactionId: this.transactionId,
        pointEntree: this.QUERY_SOURCE
      };
      this.cnafContacterMaCafService.postQuestion(
        data).subscribe({
          next: (data: any) => {
            this.postQuestionOk(data);
          },
          error: () => {
            this.postQuestionKo();
          }
        });
      window.scrollTo(0, 0);
  }

  submit(): void {

    this.etat = 'loading';
    // Désactivation du bouton à la soumission
    this.isDisabled = true;
    // Suppression Unicode "Control Characters"
    // Sauf LF,CR,Horizontal TAB

    this.messageCourriel = this.messageCourriel.
      replace(REGEX_COURRIEL.value, '');

    const data = {
      //"adresseEmail": vm.email,
      "objetMessage": this.selObjetMessage.code,
      "motifReclamation": (null === this.selMotifReclamation || (typeof this.selMotifReclamation === "undefined")) ? null : this.selMotifReclamation.code,
      "prestation": (null === this.selPrestation || (typeof this.selMotifReclamation === "undefined")) ? null : this.selPrestation.code,
      "msg": this.messageCourriel,
      "nomCaf": this.nomCaf,
      "idSousMotifMessage": this.cnafContacterMaCafService.getRnProduct(this.selObjetMessage.code)
    };
    this.cnafContacterMaCafService.postForm(
      data
    ).subscribe({
      next: (data: any) => {
        this.postFormOk(data);
      },
      error: () => {
        this.postFormKo();
      }
    });
    window.scrollTo(0, 0);
  }

  postFormOk(response: any): void {
    this.indicateursSite.x11 = this.selObjetMessage.libelleCaffr;
    const tagObj = this.tagXitiService.getAtTagObject(LIBELLE_STAT.libelleEnvoi, context.type, this.codeOrga, LIBELLE_STAT.libelleContacterMaCaf,
      LIBELLE_STAT.libelleParCourriel, null, this.indicateursSite);
    this.cnafAtTagService.pageSend(tagObj);
    let rnProductSelected = '';
    const selectedProduct = (this.cnafContacterMaCafService.isUndefOrNull(this.selObjetMessage)) ? null : this.cnafContacterMaCafService.getRnProduct(this.selObjetMessage.code);
    if (selectedProduct) {
        const res = selectedProduct.split('_');
        if (res[2]) {
          rnProductSelected = `SOUSMOTIF=${res[2]}`;
        }
    }
    this.cnafContacterMaCafService.statsSidAccesRubrique(rnProductSelected, 'DIAENTRECLAMWEB');
    this.etat = 'postFormOk';
  }

  postFormKo(): void {
    this.indicateursSite.x4 = '1';
    this.indicateursSite.x11 = this.selObjetMessage.libelleCaffr;
    const tagObj = this.tagXitiService.getAtTagObject(LIBELLE_STAT.libelleEnvoi, context.type, this.codeOrga, LIBELLE_STAT.libelleContacterMaCaf,
      LIBELLE_STAT.libelleParCourriel, null, this.indicateursSite);
    this.cnafAtTagService.pageSend(tagObj);
    this.etat = 'postFormKo';
  }

  validateFormAndBlur(): void {
    NgCnafFormFocusToFirstInvalidDirective.focusToFirstElementInvalid(this.contaterParCourrielNgForm, 120, this.elementRef);
  }

  onFormSubmit(): void {
    this.submitted = true;
    this.myForm.valid && this.isCamilleAutorisee &&
      this.selObjetMessage.code !== 'INFO_REC' ? this.submitQuestion()
      : this.myForm.valid ? this.submit()
        : this.validateFormAndBlur()
  }
  confirmerClick(){
    const message = "Confirmez-vous l'abandon de l'envoi de votre message ?";
    if(confirm(message)){
      this.redirect('/redirect/s/Redirect?page=monCompteContactCaf#/contactcaf');
      this.quitterBaseCo();
    }
  }
}

